import Vue from 'vue'
import Vuex from 'vuex'
import {coleccion_partidas_contables} from '@/FirebaseConfig'
import {secondsToFullTimestamp, obtener_periodo} from '@/Helper.js' 
export default {
    namespaced:true,
    state: {
        partidas: {
            codigo: '',
            descripcion: '',
            debe: 0,
            haber: 0,
            cartas: false,
            histograma: false,
            acumulado: false 
        },
        dialog: false,
        record: {},
        selectedKey: ''
    },
    mutations: {
        getAllItems(state, item) {
            Vue.set( state.record, item.id, {...item.data(), createdAt: secondsToFullTimestamp(item.data().createdAt)} )
        },
          clean(state,key){
            Vue.delete(state.record, key)
        }
    },
    actions: {
        getAll:(context)=>{
            context.state.record = {}
            coleccion_partidas_contables.onSnapshot(data=>data.docs.map( item => context.commit( 'getAllItems', item  ) ) )
        },
        add: async (context)=>{
                if(context.state.selectedKey==''){
                    coleccion_partidas_contables.doc(context.state.partidas.codigo).set(
                        {...context.state.partidas, 
                            createdAt: new Date, 
                            periodo: obtener_periodo(),
                            saldo: {
                                [obtener_periodo()]: {
                                    saldo: 0,
                                    periodo: obtener_periodo(),
                                    descripcion: context.state.partidas.descripcion
                                }
                            }
                        }).then(()=>{                     
                        context.commit('Helpers/launchSnackbar', '¡Se ha registrado una nueva partida contable!', { root: true })
                        context.state.dialog = false
                        context.state.loading = false
                        context.dispatch('cleanForm')
                    })
                }
                else{
                    coleccion_partidas_contables.doc(context.state.selectedKey).set({...context.state.partidas, updateAt: new Date}).then(()=>{
                        context.commit('Helpers/launchSnackbar', 'La partida contable ha sido modificado correctamente', { root: true })
                        context.state.selectedKey = ''
                        context.state.dialog = false
                        context.dispatch('cleanForm')
                    })
                }
            },
            clean:(context, key)=>{
                  coleccion_partidas_contables.doc(key).delete().then(()=>{
                  context.commit('Helpers/launchSnackbar', ' Ha sido eliminado', { root: true })            
                  context.commit('clean',key)})
            },
            get:(context, key)=>{
                coleccion_partidas_contables.doc(key).get().then(doc=>{
                context.state.partidas = doc.data()
                context.state.selectedKey = key
                context.state.dialog = true
                })
            },
            cleanForm: (context)=>{
                context.state.dialog = false
                context.state.selectedKey = ''
                context.state.partidas = {
                    codigo: '',
                    createdAt: '',
                    descripcion: '',
                    debe: 0,
                    haber: 0,
                    saldo: {},
                    cartas: false,
                    histograma: false,
                    acumulado: false, 
                    periodo: obtener_periodo()  
                }
            }
    },
    getters: {
        record: state => {
            let f = Object.keys(state.record).map(item => ({...state.record[item], key: item }) )
            return f.sort((a,b) => (a.codigo > b.codigo) ? 1 : ((b.codigo > a.codigo) ? -1 : 0))
        },
        registro_cartas: state=>{
            let f = Object.keys(state.record).map(item => ({...state.record[item], key: item }) )
            return f.filter(item=>(item.cartas))
        },
        registro_histograma: state=>{
            let arreglo = Object.keys(state.record).map(item => ({...state.record[item], key: item }) )
            let l= arreglo.filter(item=>(item.histograma))
            let f= Object.keys(l).map(item=>({...l[item].saldo}))
            return f
        },
        registro_acumulado: state=>{
            let arreglo = Object.keys(state.record).map(item => ({...state.record[item], key: item }) )
            let f= arreglo.filter(item=>(item.acumulado))
            return f
        },
        registro_balance_activo: state=>{
            let f = Object.keys(state.record).map(item => ({...state.record[item], key: item }) )
            let numeros =[ '1', '2', '3']
            return f.filter(item=>numeros.indexOf(item.codigo.charAt(0))>-1)
        },
        registro_balance_pasivo: state=>{
            let f = Object.keys(state.record).map(item => ({...state.record[item], key: item }) )
            let numeros = ['4', '5']
            return f.filter(item=>numeros.indexOf(item.codigo.charAt(0))>-1)
        },
        registro_estado: state=>{
            let f = Object.keys(state.record).map(item => ({...state.record[item], key: item }) )
            let numeros = ['6', '7', '8', '9', '0']
            return f.filter(item=>numeros.indexOf(item.codigo.charAt(0))>-1 )
        }
      },
}